history.scrollRestoration = "manual";

var videos = document.querySelectorAll(".videos .video");

videos.forEach(function (video) {
  var videoElement = video.querySelector("video");
  var teaserBtn = video.querySelector(".teaser");
  videoElement.addEventListener("webkitendfullscreen", function (event) {
    video.classList.add("video_finished");
  });
  videoElement.addEventListener("ended", function () {
    video.classList.add("video_finished");
  });
  function stopVideo() {
    video.classList.remove("video_finished");
    video.classList.remove("video_active");
    document.body.classList.remove("video_playing");
    videoElement.pause();
    videoElement.removeAttribute("tabindex");
    videoElement.removeAttribute("role");
    videoElement.removeAttribute("aria-label");
  }
  videoElement.addEventListener("keydown", function (e) {
    if (e.keyCode == 32 || e.keyCode == 13) {
      e.preventDefault();
      stopVideo();
      if (teaserBtn) teaserBtn.focus();
    }
  });
});

document.querySelectorAll(".video .teaser").forEach(function (teaserBtn) {
  teaserBtn.addEventListener("click", function (event) {
    var videoCell = teaserBtn.closest(".video");
    if (videoCell && videoCell.classList.contains("is-selected")) {
      var videoElement = videoCell.querySelector("video");
      if (videoCell.classList.contains("video_active")) {
        videoCell.classList.remove("video_finished");
        videoCell.classList.remove("video_active");
        document.body.classList.remove("video_playing");
        videoElement.pause();
        videoElement.removeAttribute("tabindex");
        videoElement.removeAttribute("role");
        videoElement.removeAttribute("aria-label");
      } else {
        videoCell.classList.add("video_active");
        document.body.classList.add("video_playing");
        videoElement.play();
        videoElement.setAttribute("tabindex", "0");
        videoElement.setAttribute("aria-label", "Video pausieren (Leertaste)");
        videoElement.setAttribute("role", "button");
        videoElement.focus();
      }
    }
  });
});

var videosContainer = document.querySelector(".videos");

if (videosContainer) {
  var flkty = new Flickity(".videos", {
    ImagesLoaded: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
  });

  flkty.on("staticClick", function (event, pointer, cellElement, cellIndex) {
    if (
      typeof cellIndex == "number" &&
      !cellElement.classList.contains("is-selected")
    ) {
      flkty.select(cellIndex);
    }
  });

  flkty.on("change", function (index) {
    if ((activeVideo = document.querySelector(".video_active"))) {
      activeVideo.querySelector("video").pause();
      activeVideo.classList.remove("video_active");
      activeVideo.classList.remove("video_finished");
      document.body.classList.remove("video_playing");
    }
  });

  function updateCarouselTabindex() {
    var allCells = document.querySelectorAll(".videos .video");
    allCells.forEach(function (cell) {
      var focusables = cell.querySelectorAll("a[href], button");
      if (cell.classList.contains("is-selected")) {
        focusables.forEach(function (el) {
          el.removeAttribute("tabindex");
        });
      } else {
        focusables.forEach(function (el) {
          el.setAttribute("tabindex", "-1");
        });
      }
    });
  }

  videosContainer.removeAttribute("tabindex");

  updateCarouselTabindex();
  flkty.on("change", updateCarouselTabindex);

  videosContainer.addEventListener("keydown", function (e) {
    if (e.keyCode == 39) {
      flkty.next();
      e.preventDefault();
      var selected = videosContainer.querySelector(
        ".video.is-selected .teaser",
      );
      if (selected) selected.focus();
    } else if (e.keyCode == 37) {
      flkty.previous();
      e.preventDefault();
      var selected = videosContainer.querySelector(
        ".video.is-selected .teaser",
      );
      if (selected) selected.focus();
    }
  });
}

if (document.body.classList.contains("animation")) {
  var load = gsap.timeline({
    defaults: {
      ease: "power3.inOut",
      duration: 1.5,
    },
  });
  load.to(".videos", {
    height: "auto",
    autoAlpha: 1,
    delay: 1,
  });
  load.to(
    ".svg_wrap.bewegt",
    {
      marginTop: 0,
    },
    "<",
  );
  load.to(
    ".videos .flickity-viewport",
    {
      x: 50,
      onComplete: function () {
        ScrollTrigger.refresh();
        gsap.to(".videos .flickity-viewport", {
          scrollTrigger: {
            trigger: ".videos .flickity-viewport",
            toggleActions: "play reverse play reverse",
            start: 0,
            end: "bottom top",
            scrub: 0.5,
          },
          x: -75,
          ease: "linear",
        });
      },
    },
    "<",
  );

  load.from(
    ".svg_wrap.bewegt svg path:last-child",
    {
      autoAlpha: 0,
      yPercent: 350,
      transformOrigin: "center",
    },
    "<",
  );

  load.from(
    ".bubbles .bubble",
    {
      scale: 0.9,
      autoAlpha: 0,
      stagger: 0.25,
      duration: 0.5,
    },
    "+=.25",
  );

  load.from(
    ".t_home .intro_text",
    {
      autoAlpha: 0,
    },
    "<",
  );

  load.from(
    ".projects .project_inner, .empty",
    {
      autoAlpha: 0,
    },
    "<",
  );

  load.from(
    ".filter",
    {
      autoAlpha: 0,
    },
    "<",
  );

  load.from(
    ".logos *",
    {
      autoAlpha: 0,
      stagger: 0.1,
    },
    "<",
  );
} else {
  gsap.to(".videos .flickity-viewport", {
    scrollTrigger: {
      trigger: ".videos .flickity-viewport",
      toggleActions: "play reverse play reverse",
      start: 0,
      end: "bottom top",
      scrub: 0.5,
    },
    x: -75,
    ease: "linear",
  });
}

if ((activeProject = document.querySelector(".is_open"))) {
  activeProject.scrollIntoView();
  var activeDetails = activeProject.querySelector(".project_details");
  var activeDetailsInner = activeProject.querySelector(
    ".project_details_inner",
  );
  if (activeDetails && activeDetailsInner) {
    var backLink = activeDetailsInner.querySelector(".back");
    if (backLink) backLink.focus();
    enableProjectFocusTrap(activeDetails, activeDetailsInner);
  }
}

if (document.body.classList.contains("filtered")) {
  document.querySelector(".projects").scrollIntoView();
}

gsap.to(".intro_text", {
  scrollTrigger: {
    trigger: ".intro_text",
    start: 0,
    end: "bottom top",
    toggleActions: "play reverse play reverse",
    scrub: 0.5,
  },
  rotation: 1,
  ease: "linear",
});

var projectPreviousFocus = null;
var projectFocusContainer = null;
var projectFocusDetails = null;

function handleProjectFocusTrap(event) {
  if (event.keyCode != 9) {
    return;
  }
  if (!projectFocusContainer) {
    return;
  }
  var focusableElements = projectFocusContainer.querySelectorAll(
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
  );
  if (!focusableElements.length) {
    return;
  }
  var firstElement = focusableElements[0];
  var lastElement = focusableElements[focusableElements.length - 1];
  if (event.shiftKey) {
    if (
      document.activeElement === firstElement ||
      !projectFocusContainer.contains(document.activeElement)
    ) {
      lastElement.focus();
      event.preventDefault();
    }
  } else {
    if (
      document.activeElement === lastElement ||
      !projectFocusContainer.contains(document.activeElement)
    ) {
      firstElement.focus();
      event.preventDefault();
    }
  }
}

function enableProjectFocusTrap(projectDetails, projectDetailsInner) {
  projectFocusDetails = projectDetails;
  projectFocusContainer = projectDetailsInner;
  if (projectFocusDetails) {
    projectFocusDetails.addEventListener("keydown", handleProjectFocusTrap);
  }
}

function disableProjectFocusTrap() {
  if (projectFocusDetails) {
    projectFocusDetails.removeEventListener("keydown", handleProjectFocusTrap);
  }
  projectFocusDetails = null;
  projectFocusContainer = null;
}

function openProject(project, projectLink, projectDetails, href) {
  if (!project.classList.contains("flipping")) {
    var projectDetailsInner = projectDetails.querySelector(
      ".project_details_inner",
    );
    projectPreviousFocus = document.activeElement;
    disableProjectFocusTrap();
    document.body.classList.add("project_open");
    const state = Flip.getState(projectLink);
    project.classList.add("is_open");
    project.classList.add("flipping");
    gsap.set(projectDetails, { opacity: 0 });
    gsap.to(projectDetails, {
      autoAlpha: 1,
      duration: 0.6,
      ease: "power3.inOut",
    });
    if (projectDetails.querySelector(".image")) {
      gsap.from(projectDetails.querySelector(".image"), {
        y: 100,
        rotation: 0,
        duration: 0.6,
        ease: "power3.inOut",
      });
    }
    Flip.from(state, {
      targets: projectDetailsInner,
      duration: 0.6,
      scale: true,
      simple: true,
      absolute: false,
      ease: "power3.inOut",
      zIndex: 1000,
      onComplete: function () {
        project.classList.remove("flipping");
        var backLink = projectDetailsInner.querySelector(".back");
        if (backLink) {
          backLink.focus();
        }
        enableProjectFocusTrap(projectDetails, projectDetailsInner);
      },
    });
    history.pushState(null, null, href);
  }
}

function closeProject(project, projectLink, projectDetails) {
  if (!project.classList.contains("flipping")) {
    var projectDetailsInner = projectDetails.querySelector(
      ".project_details_inner",
    );
    document.body.classList.remove("project_open");
    const state = Flip.getState(projectLink);
    project.classList.add("flipping");
    gsap.to(projectDetails, {
      autoAlpha: 0,
      duration: 0.6,
      ease: "power3.inOut",
    });
    gsap.to(projectDetails.querySelector(".image"), {
      rotation: 0,
      duration: 0.6,
      ease: "power3.inOut",
      onComplete: function () {
        gsap.set(projectDetails.querySelector(".image"), { clearProps: "all" });
      },
    });
    Flip.to(state, {
      targets: projectDetailsInner,
      duration: 0.6,
      scale: true,
      simple: true,
      absolute: false,
      ease: "power3.inOut",
      onComplete: function () {
        project.classList.remove("is_open");
        gsap.set(projectDetails, { opacity: 1 });
        gsap.set(projectDetailsInner, { clearProps: "all" });
        project.classList.remove("flipping");
        disableProjectFocusTrap();
        if (
          projectPreviousFocus &&
          typeof projectPreviousFocus.focus == "function"
        ) {
          projectPreviousFocus.focus();
        }
        projectPreviousFocus = null;
      },
    });
    history.pushState(null, null, document.body.dataset.url);
  }
}

document.querySelectorAll(".project").forEach(function (project) {
  var projectLink = project.querySelector(".project_inner");
  var projectDetails = project.querySelector(".project_details");
  var href = projectLink.getAttribute("href");
  if (projectDetails && projectDetails) {
    projectLink.addEventListener("click", function (event) {
      openProject(project, projectLink, projectDetails, href);
      event.preventDefault();
    });
    projectDetails
      .querySelector(".back")
      .addEventListener("click", function (event) {
        closeProject(project, projectLink, projectDetails);
        event.preventDefault();
      });
  }
});

document.addEventListener("keydown", function (e) {
  if (e.keyCode == 27) {
    var project = document.querySelector(".project.is_open");
    if (project) {
      var projectLink = project.querySelector(".project_inner");
      var projectDetails = project.querySelector(".project_details");
      closeProject(project, projectLink, projectDetails);
    }
  }
});

document.addEventListener("click", function (e) {
  var project = document.querySelector(".project.is_open");
  if (project) {
    var isClickInside = project
      .querySelector(".project_details_inner")
      .contains(event.target);
    if (!isClickInside) {
      var projectLink = project.querySelector(".project_inner");
      var projectDetails = project.querySelector(".project_details");
      closeProject(project, projectLink, projectDetails);
    }
  }
});

gsap.to(".bubbles1 .bubble", {
  scrollTrigger: {
    trigger: ".bubbles1 .bubble",
    start: 0,
    end: "bottom top",
    toggleActions: "play reverse play reverse",
    scrub: 0.5,
  },
  y: 20,
  rotation: "random(-3deg, 0deg)",
  ease: "linear",
});

gsap.to(".bubbles2 .bubble", {
  scrollTrigger: {
    trigger: ".bubbles2 .bubble",
    start: "top bottom",
    end: "bottom top",
    toggleActions: "play reverse play reverse",
    scrub: 0.5,
  },
  y: 20,
  rotation: "random(-1deg, 1deg)",
  ease: "linear",
});

gsap.to(".calltoaction .bubble", {
  scrollTrigger: {
    trigger: ".calltoaction .bubble",
    start: "top bottom",
    end: "top center",
    toggleActions: "play reverse play reverse",
    scrub: 0.5,
  },
  rotation: "random(-2deg, 2deg)",
  scale: 1,
  ease: "linear",
});

document
  .querySelectorAll("footer svg path, .t_error svg path")
  .forEach(function (letter) {
    var bounce = gsap.timeline();
    letter.addEventListener("mouseenter", function () {
      if (letter.dataset.animating != "true") {
        letter.dataset.animating = "true";
        bounce.to(letter, {
          y: "random(-50, -10)",
          ease: "power3",
        });
        bounce.to(
          letter,
          {
            y: 0,
            ease: "bounce",
            onComplete: function () {
              letter.dataset.animating = "false";
            },
          },
          "-=.25",
        );
      }
    });
  });

document.querySelectorAll(".filter_button").forEach(function (button) {
  var buttonHover = gsap.timeline({ paused: true });
  buttonHover.to(button.querySelector(".title"), {
    rotation: 0,
    duration: 0.25,
  });
  button.querySelector(".title").addEventListener("mouseenter", function () {
    buttonHover.play();
  });
  button.querySelector(".title").addEventListener("mouseleave", function () {
    buttonHover.reverse();
  });
  var dropdown = gsap.timeline({ paused: true });
  dropdown.to(button.querySelectorAll(".option"), {
    autoAlpha: 1,
    y: 0,
    stagger: -0.035,
    duration: 0.25,
    ease: "power1.inOut",
  });
  dropdown.to(
    button.querySelector(".title svg"),
    {
      rotation: 540,
      duration: 0.5,
      ease: "power1.inOut",
    },
    0,
  );
  function focusFirstOption() {
    var firstOption = button.querySelector(".option");
    if (firstOption) {
      firstOption.focus();
    }
  }
  button.querySelector(".title").addEventListener("click", function () {
    if (button.classList.contains("open")) {
      button.classList.remove("open");
      button.querySelector(".title").setAttribute("aria-expanded", "false");
      dropdown.reverse();
    } else {
      button.classList.add("open");
      button.querySelector(".title").setAttribute("aria-expanded", "true");
      dropdown.eventCallback("onComplete", function () {
        focusFirstOption();
      });
      dropdown.play();
    }
  });

  button.addEventListener("keydown", function (event) {
    if (event.keyCode == 27 && button.classList.contains("open")) {
      button.classList.remove("open");
      button.querySelector(".title").setAttribute("aria-expanded", "false");
      dropdown.reverse();
      button.querySelector(".title").focus();
      event.preventDefault();
    }
  });

  button.addEventListener("focusout", function (event) {
    setTimeout(function () {
      if (!button.contains(document.activeElement)) {
        if (button.classList.contains("open")) {
          button.classList.remove("open");
          button.querySelector(".title").setAttribute("aria-expanded", "false");
          dropdown.reverse();
        }
      }
    }, 10);
  });

  function filter() {
    var projects = document.querySelectorAll(".project");
    var startHeight = gsap.getProperty(".projects_inner", "height");
    var state = Flip.getState(".project, .empty");
    var filters = document.querySelectorAll(".option.is_active");

    if (filters.length) {
      projects.forEach(function (project) {
        gsap.set(project, { display: "block" });
        project.classList.remove("filtered");
      });
      filters.forEach(function (filter) {
        var type = filter.dataset.filter.split(":")[0];
        var value = filter.dataset.filter.split(":")[1];
        projects.forEach(function (project) {
          if (project.getAttribute("data-" + type) != value) {
            gsap.set(project, { display: "none" });
            project.classList.add("filtered");
          }
        });
      });
    } else {
      projects.forEach(function (project) {
        gsap.set(project, { display: "block" });
        project.classList.remove("filtered");
      });
    }

    if (document.querySelectorAll(".project:not(.filtered)").length) {
      gsap.set(".empty", { display: "none" });
    } else {
      gsap.set(".empty", { display: "block" });
    }

    var endHeight = gsap.getProperty(".projects_inner", "height");

    var flip = Flip.from(state, {
      duration: 0.6,
      ease: "power3.inOut",
      stagger: 0.04,
      absolute: true,
      simple: true,
      onEnter: (elements) =>
        gsap.fromTo(
          elements,
          { opacity: 0, scale: 0 },
          {
            opacity: 1,
            scale: 1,
            duration: 0.6,
            stagger: 0.04,
            ease: "power3.inOut",
          },
        ),
      onLeave: (elements) =>
        gsap.to(elements, {
          opacity: 0,
          scale: 0,
          duration: 0.6,
          stagger: 0.04,
          ease: "power3.inOut",
        }),
    });
    flip.fromTo(
      ".projects_inner",
      {
        height: startHeight,
      },
      {
        height: endHeight,
        clearProps: "height",
        ease: "power3.inOut",
        duration: flip.duration(),
      },
      0,
    );
  }

  button.querySelectorAll(".option").forEach(function (option) {
    var optionHover = gsap.timeline({ paused: true });
    optionHover.to(option, {
      rotation: "+=2",
      duration: 0.25,
    });
    option.addEventListener("mouseenter", function () {
      optionHover.play();
    });
    option.addEventListener("mouseleave", function () {
      optionHover.reverse();
    });
    option.addEventListener("click", function (event) {
      var target = event.currentTarget;

      var is_active = false;
      button.querySelectorAll(".option").forEach(function (option2) {
        if (option2.classList.contains("is_active")) {
          option2.classList.remove("is_active");
          option2.setAttribute("aria-selected", "false");
          if (option2 == option) {
            is_active = true;
          }
        }
      });

      if (is_active) {
        button.classList.remove("has_active");
        target.setAttribute("aria-selected", "false");
      } else {
        target.classList.add("is_active");
        target.setAttribute("aria-selected", "true");
        button.classList.add("has_active");
      }

      filter();

      target.classList.add("was_clicked");
      setTimeout(function () {
        target.classList.remove("was_clicked");
      }, 500);

      filterHref = document.body.dataset.url;
      document
        .querySelectorAll(".option.is_active")
        .forEach(function (activeOption) {
          filterHref += "/" + activeOption.dataset.filter;
        });

      history.pushState(null, null, filterHref);

      setTimeout(function () {
        button.classList.remove("open");
        button.querySelector(".title").setAttribute("aria-expanded", "false");
        dropdown.reverse();
      }, 250);

      event.preventDefault();
    });
  });
});

const panels = document.querySelectorAll(".panel");

function updatePanelTabindex(panel_content, hidden) {
  var focusables = panel_content.querySelectorAll(
    "a[href], button, textarea, input, select",
  );
  focusables.forEach(function (el) {
    if (hidden) {
      el.setAttribute("tabindex", "-1");
    } else {
      el.removeAttribute("tabindex");
    }
  });
}

panels.forEach(function (panel) {
  const panel_content = panel.querySelector(".panel_content");
  const panel_headline = panel.querySelector(".headline");

  updatePanelTabindex(panel_content, true);

  panel.openPanel = gsap.timeline({
    paused: true,
    defaults: { duration: 0.25, ease: "power2.inOut" },
  });
  panel.openPanel.fromTo(
    panel_content,
    {
      height: 0,
    },
    {
      height: "auto",
    },
  );

  panel_headline.addEventListener("click", function (event) {
    if (panel.classList.contains("is_open")) {
      panel.classList.remove("is_open");
      panel.openPanel.reverse();
      panel_headline.setAttribute("aria-expanded", "false");
      panel_content.setAttribute("aria-hidden", "true");
      updatePanelTabindex(panel_content, true);
      history.replaceState(null, null, "#!");
    } else {
      panel.classList.add("is_open");
      panel.openPanel.play();
      panel_headline.setAttribute("aria-expanded", "true");
      panel_content.setAttribute("aria-hidden", "false");
      updatePanelTabindex(panel_content, false);
      history.replaceState(null, null, "#" + panel.id);
    }
    event.preventDefault();
  });
});

if (panels.length && window.location.hash && window.location.hash != "#!") {
  if ((activePanel = document.querySelector(window.location.hash))) {
    activePanel.querySelector(".headline").click();
    activePanel.querySelector(".headline").focus();
  }
}

ScrollTrigger.matchMedia({
  "(min-width: 1000px)": function () {
    gsap.set(".panel .headline", {
      x: "random(-20, 20)",
      rotation: "random(-1, 1)",
    });
  },
  "(max-width: 999px)": function () {
    gsap.set(".panel .headline", {
      x: 0,
      rotation: 0,
    });
  },
});

if (document.querySelector(".faq a")) {
  document.querySelector(".faq a").addEventListener("click", function (e) {
    history.back();
    e.preventDefault();
  });
}
